import { DateRange } from 'bold-ui'
import { format, subDays, subYears } from 'date-fns'
import { HistoricoFiltrosAvancadosQueryInput, HistoricoQueryInput, OrigemDadoEnum } from 'graphql/types.generated'
import { ExibirPorHistoricoAtendimentoFilterEnum } from 'types/enums'
import { convertSortDirectionToSort } from 'util/sort-direction/converter-sortDirection'

import {
  HistoricoAtendimentoAdvancedFilterFormModel,
  HistoricoAtendimentoFilterFormModel,
  IdadeOrigemAtendimento,
} from './model/model-historico'

export function convertToInput(
  filtros: HistoricoAtendimentoFilterFormModel,
  dataAtendimento: Date
): HistoricoQueryInput {
  return {
    pageParams: filtros.pageParams,
    cidadaoId: filtros.cidadaoId,
    cidadaoCpf: filtros.cidadaoCpf,
    profissionalCpf: filtros.somenteMeusRegistros ? filtros.profissionalCpf : null,
    somenteMeusRegistros: !!filtros.somenteMeusRegistros,
    tiposRegistro: filtros.tiposRegistro,
    unidadeSaudeCnes: filtros.unidadeSaudeCnes,
    equipeIne: filtros.equipeIne,
    sortDirection: convertSortDirectionToSort(filtros.sortDirection),
    filtrosAvancados: convertFiltrosAvancados(filtros.filtrosAvancados, dataAtendimento, filtros.periodoExibicao),
  }
}

function convertFiltrosAvancados(
  filtrosAvancados: HistoricoAtendimentoAdvancedFilterFormModel,
  dataAtendimento: Date,
  periodoExibicao: ExibirPorHistoricoAtendimentoFilterEnum
): HistoricoFiltrosAvancadosQueryInput {
  return {
    cod2002Cbos: filtrosAvancados.cbos?.map((item) => item.cbo2002),
    ineEquipes: filtrosAvancados.equipes?.map((item) => item.ine),
    cpfProfissionais: filtrosAvancados.profissionais?.map((item) => item.cpf),
    periodo: convertPeriodoExibicaoToPeriodo(dataAtendimento, periodoExibicao, filtrosAvancados.periodo),
    codCiaps2: filtrosAvancados.ciaps2?.map((item) => item.codigo),
    codCids10: filtrosAvancados.cids10?.map((item) => item.codigo),
    exibirRegistrosInativos: filtrosAvancados.exibirRegistrosInativos,
    somenteRegistrosComErrataNotaComplementar: filtrosAvancados.somenteRegistrosComErrataNotaComplementar,
  }
}

const convertPeriodoExibicaoToPeriodo = (
  dataAtendimento: Date,
  periodoExibicao: ExibirPorHistoricoAtendimentoFilterEnum,
  periodoPersonalizado?: DateRange
): DateRange => {
  const today = dataAtendimento
  switch (periodoExibicao) {
    case ExibirPorHistoricoAtendimentoFilterEnum.ULTIMOS_TRINTA_DIAS:
      return { startDate: subDays(today, 30), endDate: today } as DateRange
    case ExibirPorHistoricoAtendimentoFilterEnum.ULTIMOS_SESSENTA_DIAS:
      return { startDate: subDays(today, 60), endDate: today } as DateRange
    case ExibirPorHistoricoAtendimentoFilterEnum.ULTIMOS_NOVENTA_DIAS:
      return { startDate: subDays(today, 90), endDate: today } as DateRange
    case ExibirPorHistoricoAtendimentoFilterEnum.ULTIMO_ANO:
      return { startDate: subYears(today, 1), endDate: today } as DateRange
    case ExibirPorHistoricoAtendimentoFilterEnum.PERSONALIZADO:
      return periodoPersonalizado
    default:
      return null
  }
}

export const convertIdadeOrigemAtendimento = (
  dataNascimentoCidadao: LocalDate,
  dataAtendimento?: Instant,
  origemAtendimento?: OrigemDadoEnum
): IdadeOrigemAtendimento => ({
  dataAtendimento: format(dataAtendimento, 'yyyy-MM-dd'),
  dataNascimentoCidadao,
  origemAtendimento: origemAtendimento,
})
